import React from 'react';
import {useTranslation} from "react-i18next";

const Copyright = ({name}) => {

    const {t} = useTranslation();

    return(
        <div className="copyright-text">{"\u00A9"} {`${(new Date().getFullYear())} ${t("lbl.COPYRIGHT","Copyright LGI Healthcare Solutions Inc.")}`}</div>
    );
}

export default Copyright;




